import * as cx from 'classnames';
import * as React from 'react';
import styles from './Panel.mscss';

interface OwnProps {
    className?: string;
    style?: React.CSSProperties;
    tag?: string;
}

type Props = OwnProps;

const Panel: React.StatelessComponent<Props> = ({ className, style, children, tag = 'div' }) => {
    const Tag: any = tag;

    return (
        <Tag className={cx(styles.Panel, className)} style={style}>
            {children}
        </Tag>
    );
};

export default Panel;
